.github-box {
    font-family: helvetica, arial, sans-serif;
    font-size: 13px;
    line-height: 18px;
    background: #fafafa;
    border: 1px solid #ddd;
    color: #666;
    border-radius: 3px;

    a {
        color: #4183c4;
        border: none;
    }
}
.github-box-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #ddd;
    border-radius: 3px 3px 0 0;
    background: linear-gradient(#fcfcfc, #ebebeb);

    h3 {
        font-family: helvetica, arial, sans-serif;
        font-weight: normal;
        font-size: 1rem;
        color: gray;
        margin: 0;

        & > * {
            display: inline-block;
            vertical-align: middle;
        }
    }
}
.github-stats {
    margin: auto 0.5rem;
    background: white;
    border: 1px solid #ddd;
    border-radius: 3px;
    font-size: 11px;
    font-weight: bold;

    a {
        display: inline-block;
        vertical-align: middle;
        color: #666;
        padding: 0 5px 0 18px;
        background-repeat: no-repeat;
    }
    .watchers {
        border-right: 1px solid #ddd;
    }
    .forks {
        background-position: -4px -21px;
        padding-left: 15px;
    }
}

.github-box-content {
    padding: 10px;
    font-weight: 300;
}

.github-box-download {
    display: flex;
    justify-content: space-between;
    border-top: 1px solid #ddd;
    background: white;
    border-radius: 0 0 3px 3px;
    padding: 10px;

    .updated {
        margin: 0;
        font-size: 11px;
        color: #666;
        font-weight: 300;
    }

    .download {
        font-size: 12px;
        color: #666;
        font-weight: bold;
        text-decoration: none;
        text-shadow: 0 1px 0 rgba(255, 255, 255, 0.9);
        padding: 0 10px;
        border: 1px solid #ddd;
        border-bottom-color: #bbb;
        border-radius: 3px;
        background: linear-gradient(#f5f5f5, #e5e5e5);
    }
    .download:hover {
        color: #527894;
        border-color: #cfe3ed;
        border-bottom-color: #9fc7db;
        background: linear-gradient(#f1f7fa, #dbeaf1);
    }
}
